<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        v-if="$canEdit"
        class="filter-item"
        type="success"
        size="small"
        @click="handleCreate"
        >充值
      </el-button>
      充值时间:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      实际充值时间:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr1"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="small"
      >
        <el-option label="已到账" value="received" />
        <el-option label="已撤回" value="revoked" />
      </el-select>
      <el-input
        style="width: 200px"
        v-model="listQuery.app_client_id"
        placeholder="企业ID"
        clearable
        class="filter-item"
        size="small"
      ></el-input>
      <el-input
        style="width: 200px"
        v-model="listQuery.name"
        placeholder="企业名称"
        clearable
        class="filter-item"
        size="small"
      ></el-input>

      <el-input
        style="width: 200px"
        v-model="listQuery.full_name"
        placeholder="企业全称"
        clearable
        class="filter-item"
        size="small"
      ></el-input>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-row> </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="企业ID" min-width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.app_client_id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="企业名称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.app_client.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="企业全称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.app_client.full_name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="充值时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="实际充值时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.actual_recharge_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="充值金额" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status !== 'received'" type="info">
            {{ scope.row.money }}</el-tag
          >
          <el-tag v-else type="success"> {{ scope.row.money }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="充值后剩余额度" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.after_available_quota }}
        </template>
      </el-table-column>
      <el-table-column label="充值后开票余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.after_balance }}
        </template>
      </el-table-column>
      <el-table-column label="银行回单预览" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.bank_receipts"
            style="width: 100px; height: 100px"
            :src="JSON.parse(scope.row.bank_receipts)[0]"
            :preview-src-list="JSON.parse(scope.row.bank_receipts)"
          >
          </el-image>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'received'" type="success"
            >已到账</el-tag
          >
          <el-tag v-else type="warning">已撤回</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="充值操作人员" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            scope.row.recharge_admin ? scope.row.recharge_admin.username : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="回退操作人员" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.revoke_admin ? scope.row.revoke_admin.username : '-' }}
        </template>
      </el-table-column>
      <!--      <el-table-column class-name="status-col" label="状态" min-width="110" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>-->
      <!--          <el-tag v-else type="warning">禁用</el-tag>-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column
        label="操作"
        align="center"
        width="230"
        v-if="$canEdit"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 'received'"
            type="warning"
            size="mini"
            @click="revoke(scope.row.id)"
          >
            回退
          </el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handleEditReceipt(scope.row)"
            >修改上传银行回单</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="充值"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="客户名称" prop="app_client_id">
          <el-select
            v-model="form.app_client_id"
            filterable
            remote
            placeholder="请输入客户名称搜索"
            :remote-method="fetchClientNames"
            :loading="loadingClients"
            style="width: 100%"
            @change="onClientChange"
          >
            <el-option
              v-for="item in clientNameOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <span
            v-if="selectedClientFullName"
            style="color: #999; font-size: 12px"
          >
            企业全称：{{ selectedClientFullName }}
          </span>
        </el-form-item>

        <el-form-item label="金额" prop="money">
          <el-input v-model="form.money" />
        </el-form-item>
        <el-form-item label="实际充值时间" prop="actual_recharge_at">
          <el-date-picker
            v-model="form.actual_recharge_at"
            type="datetime"
            placeholder="请选择时间"
          />
        </el-form-item>
        <el-form-item label="上传银行回单" prop="bank_receipts">
          <upload-list v-model="form.bank_receipts" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="修改上传银行回单"
      :visible.sync="dialogVisibleReceipt"
      :close-on-click-modal="false"
    >
      <el-form
        ref="receiptForm"
        :rules="receiptRules"
        :model="receiptForm"
        label-position="left"
        label-width="120px"
        style="margin-left: 50px"
      >
        <el-form-item label="银行回单" prop="bank_receipts">
          <upload-list v-model="receiptForm.bank_receipts" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReceipt = false">取消</el-button>
        <el-button type="primary" @click="saveReceipt" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'
import moment from 'moment/moment'

export default {
  components: { uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      data: {},
      types: [],
      form: {
        app_client_id: undefined,
        money: 0,
        actual_recharge_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        bank_receipts: [],
      },
      rules: {
        app_client_id: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        money: [
          { required: true, message: '充值金额不能为空', trigger: 'blur' },
        ],
        actual_recharge_at: [
          { required: true, message: '实际充值时间不能为空', trigger: 'blur' },
        ],
      },
      btnLoading: false,
      dialogFormVisible1: false,
      dialogStatus1: '',
      textMap1: {
        update: '编辑',
        create: '添加',
      },
      form1: {
        app_client_id: '',
        buyer_name: undefined,
        buyer_taxpayer_no: undefined,
        address: undefined,
        phone: undefined,
        bank: undefined,
        taxpayer_qualification_type: undefined,
        invoicing_type: undefined,
        email: undefined,
        remark: undefined,
      },
      rules1: {
        buyer_name: [
          { required: true, message: '购买方名称不能为空', trigger: 'blur' },
        ],
        buyer_taxpayer_no: [
          {
            required: true,
            message: '购买方纳税人识别号不能为空',
            trigger: 'blur',
          },
        ],
      },
      btnLoading1: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      receiptRules: {
        bank_receipts: [
          { required: true, message: '请上传银行回单', trigger: 'change' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      dateArr: null,
      dateArr1: null,
      total_money: 0,
      clientNameOptions: [],
      loadingClients: false,
      selectedClientFullName: '',
      dialogVisibleReceipt: false,
      receiptForm: {
        id: '',
        bank_receipts: [],
      },
      receiptRules: {
        bank_receipts: [
          { required: true, message: '请上传银行回单', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0] + ' 00:00:00'
        this.listQuery.end_at = newVal[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    dateArr1(newVal, oldVal) {
      if (newVal) {
        this.listQuery.actual_start_at = newVal[0] + ' 00:00:00'
        this.listQuery.actual_end_at = newVal[1] + ' 23:59:59'
      } else {
        this.listQuery.actual_start_at = ''
        this.listQuery.actual_end_at = ''
      }
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/app-client-recharge/logs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.total_money = response.data.count.total_money || 0
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleCreate() {
      this.resetForm()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    fetchClientNames(query) {
      if (!query) {
        this.clientNameOptions = []
        return
      }
      this.loadingClients = true
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: { name: query },
      })
        .then((response) => {
          const list = response.data.data || []
          this.clientNameOptions = list.map((item) => ({
            label: item.name,
            value: item.id,
            full_name: item.full_name,
          }))
          this.loadingClients = false
        })
        .catch(() => {
          this.loadingClients = false
        })
    },
    onClientChange(val) {
      const selected = this.clientNameOptions.find((item) => item.value === val)
      this.selectedClientFullName = selected ? selected.full_name : ''
    },
    resetForm() {
      this.form = {
        app_client_id: undefined,
        money: 0,
      }
      this.selectedClientFullName = ''
      this.btnLoading = false
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.actual_recharge_at = moment(
            this.form.actual_recharge_at,
          ).format('YYYY-MM-DD HH:mm:ss')
          this.btnLoading = true
          request({
            url: '/api/backend/app-client-recharge/recharge',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    revoke(id) {
      this.$confirm('此操作将修改记录状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client-recharge/revoke',
            method: 'post',
            data: { id: id },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleEditReceipt(row) {
      let bankReceipts = row.bank_receipts || []
      if (typeof bankReceipts === 'string') {
        try {
          bankReceipts = JSON.parse(bankReceipts)
        } catch (e) {
          bankReceipts = []
        }
      }
      this.receiptForm = {
        id: row.id,
        bank_receipts: bankReceipts,
      }
      this.dialogVisibleReceipt = true
      this.$nextTick(() => {
        this.$refs['receiptForm'].clearValidate()
      })
    },
    saveReceipt() {
      this.$refs['receiptForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/app-client-recharge/update-bank-receipt',
            method: 'post',
            data: this.receiptForm,
          })
            .then(() => {
              this.btnLoading = false
              this.dialogVisibleReceipt = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box-card {
  text-align: center;

  .value {
    color: #546dfe;
    font-weight: bold;
    font-size: 26px;
  }

  .subtitle {
    font-size: 12px;
    color: gray;
    margin-top: 6px;
  }
}

.el-row {
  margin-bottom: 20px;
}

::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}
::v-deep .el-date-editor .el-range-separator {
  width: 8%;
}
</style>
